// docments-setup.ts

import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { Table } from '../../../shared/table/table';

import {
  TableColumn,
} from '../../../shared/models/table-models';

import { AdminService } from '../../shared/service/admin.service';

@Component({
  selector: 'app-docments-setup',
  standalone: true,
  imports: [
    TranslatePipe,
    CommonModule,
    FormsModule,
  ],
  templateUrl: './docments-setup.html',
  styleUrl: './docments-setup.css',
})
export class DocmentsSetup implements OnInit {

  constructor(
    private router: Router,
    private adminService: AdminService,
  ) {}

  // =========================================
  // VARIABLES
  // =========================================

  list: any[] = [];

  // =========================================
  // INIT
  // =========================================

  ngOnInit(): void {

    this.getAllModes();

  }

  // =========================================
  // GET ALL MODES
  // =========================================

  getAllModes(): void {

    this.adminService
      .getAllModes()
      .subscribe({

        next: (res: any[]) => {

          this.list = (res || []).map(
            (item: any) => ({

              // module seq
              id:
                item.modSeq,

              // module name
              module:
                item.modNm,

              raw: item,

            })
          );

        },

        error: (err) => {

          console.error(err);

        },

      });

  }

  // =========================================
  // TABLE COLUMNS
  // =========================================

  columns: TableColumn[] = [

    {
      key: 'module',

      label: 'SETUP.DOCUMENTS.MODULE_NAME',

      type: 'link',

      onClick: (row: any) =>
        this.goToDocumentTypes(row),
    },

  ];

  // =========================================
  // NAVIGATE
  // =========================================

  goToDocumentTypes(row: any): void {

    this.router.navigate([
      '/document-types',
      row.id,
    ]);

  }

}